import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { useMobileMode } from '../../hooks/useMobileMode.js';
import { style } from '../../utils/style.js';
import { renderDotButton } from './renderDotButton.js';
import { renderNavButton } from './renderNavButton.js';
import { SwipeListContainer } from './SwipeListContainer.js';
import { useSwipeListScroll } from './useSwipeListScroll.js';
const containerStyles = {
    'horizontal-list': 'mx-auto mt-lg w-fit',
    'vertical-list': 'absolute flex-col justify-center h-full top-0 left-4',
};
export const SwipeListDots = JSX(({ className = '', activeIndex = 0, dotCount = 0, listType = 'horizontal-list', version, navButtons = [], containerRef, containerScroll, }) => {
    const isMobileMode = useMobileMode();
    const [navRef, navScroll] = useSwipeListScroll({
        itemCount: navButtons.length,
    });
    const scrollOption = getOptions(Boolean(navButtons?.length));
    useEffect(() => {
        if (navButtons?.length && activeIndex >= 0 && navRef?.current) {
            navScroll.scrollTo(activeIndex, scrollOption);
        }
    }, [activeIndex]);
    const onChangeActiveIndex = useCallback((idx) => {
        if (idx !== activeIndex && containerRef?.current) {
            containerScroll?.scrollTo(idx, scrollOption);
        }
    }, [containerRef?.current]);
    if (navButtons?.length && !isMobileMode) {
        return (_jsx(SwipeListContainer, { containerRef: navRef, snapAlign: "snap-start", itemClassName: "h-36 flex items-stretch w-screen", gap: 8, children: navButtons.map(renderNavButton({ activeIndex, onClick: onChangeActiveIndex })) }));
    }
    else if (dotCount) {
        return (_jsx("div", { className: style('flex gap-xs', containerStyles[listType], version ? 'group' : '', className, { 'pb-xl': navButtons?.length && isMobileMode }), "data-ver": version, children: Array.from({ length: dotCount })
                .fill(null)
                .map(renderDotButton({ activeIndex, onClick: onChangeActiveIndex, listType })) }));
    }
    return null;
});
const getOptions = (isAuto = false) => ({
    behavior: isAuto ? 'auto' : 'smooth',
});
//# sourceMappingURL=SwipeListDots.js.map